module.exports = __webpack_public_path__ + "media/images/v2/youtube_logo-ed7052db01088637057dae96055cee51.png";